function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { system } from "styled-system";
import { transformCssCustomProperty } from "./transforms";
var colorConfig = {
  property: "color",
  scale: "colors",
  transform: function transform(value) {
    return transformCssCustomProperty("colors", value);
  }
};

var backgroundColorConfig = _extends({}, colorConfig, {
  property: "backgroundColor"
});

var borderColorConfig = _extends({}, colorConfig, {
  property: "borderColor"
});

var borderTopColorConfig = _extends({}, colorConfig, {
  property: "borderTopColor"
});

var borderRightColorConfig = _extends({}, colorConfig, {
  property: "borderRightColor"
});

var borderBottomColorConfig = _extends({}, colorConfig, {
  property: "borderBottomColor"
});

var borderLeftColorConfig = _extends({}, colorConfig, {
  property: "borderLeftColor"
});

export var color = system({
  textColor: colorConfig,
  tc: colorConfig,
  backgroundColor: backgroundColorConfig,
  bg: backgroundColorConfig,
  borderColor: borderColorConfig,
  bc: borderColorConfig,
  borderTopColor: borderTopColorConfig,
  btc: borderTopColorConfig,
  borderRightColor: borderRightColorConfig,
  brc: borderRightColorConfig,
  borderBottomColor: borderBottomColorConfig,
  bbc: borderBottomColorConfig,
  borderLeftColor: borderLeftColorConfig,
  blc: borderLeftColorConfig
});
export default color;